<div class="container-fluid text-center wrapper">
    <h2 class="small-heading">finzyPRO+ Master Rating Preference</h2>
    <p>
        finzyPRO+ is our automated scientific algorithm that allows you to diversify your investments granularly across
        loans. This proprietary logic also balances the risk and return in line with your your custom risk preferences.
        Amount allocated in any loan will be dependent upon your preference and the portfolio amount, subject to the
        maximum amounts mentioned in the table below:
    </p>
    <div class="w-100" style="overflow: scroll">
        <table class="table">
            <thead>
            <tr>
                <th>Portfolio Amount</th>
                <th>A+1 - A+3</th>
                <th>A1 - A3</th>
                <th>A4 - A6</th>
                <th>B1 - B3</th>
                <th>B4 - B6</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td class="text-left">
                    <app-indian-currency-formatter amount="10000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                    and below
                </td>
                <td colspan="5">Not more than
                    <app-indian-currency-formatter amount="1000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                    per loan
                </td>
            </tr>
            <tr>
                <td class="text-left">
                    <app-indian-currency-formatter amount="10001"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                    to
                    <app-indian-currency-formatter amount="100000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
                <td>
                    <app-indian-currency-formatter amount="10000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
                <td>
                    <app-indian-currency-formatter amount="10000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
                <td>
                    <app-indian-currency-formatter amount="10000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
                <td>
                    <app-indian-currency-formatter amount="5000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
                <td>
                    <app-indian-currency-formatter amount="3000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
            </tr>
            <tr>
                <td class="text-left">
                    <app-indian-currency-formatter amount="100001"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                    to
                    <app-indian-currency-formatter amount="500000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
                <td>
                    <app-indian-currency-formatter amount="30000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
                <td>
                    <app-indian-currency-formatter amount="30000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
                <td>
                    <app-indian-currency-formatter amount="20000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
                <td>
                    <app-indian-currency-formatter amount="10000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
                <td>
                    <app-indian-currency-formatter amount="5000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
            </tr>
            <tr>
                <td class="text-left">
                    <app-indian-currency-formatter amount="500001"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                    to
                    <app-indian-currency-formatter amount="1000000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
                <td>
                    <app-indian-currency-formatter amount="40000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
                <td>
                    <app-indian-currency-formatter amount="40000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
                <td>
                    <app-indian-currency-formatter amount="30000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
                <td>
                    <app-indian-currency-formatter amount="20000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
                <td>
                    <app-indian-currency-formatter amount="10000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
            </tr>
            <tr>
                <td class="text-left">
                    <app-indian-currency-formatter amount="1000001"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                    to
                    <app-indian-currency-formatter amount="5000000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
                <td>
                    <app-indian-currency-formatter amount="50000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
                <td>
                    <app-indian-currency-formatter amount="50000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
                <td>
                    <app-indian-currency-formatter amount="30000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
                <td>
                    <app-indian-currency-formatter amount="20000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
                <td>
                    <app-indian-currency-formatter amount="10000"
                                                   minimumFractionDigits="0"></app-indian-currency-formatter>
                </td>
            </tr>
            </tbody>
        </table>
    </div>

    <p class="small-text">
        Please note that maximum amounts to be allocated to a loan (for a particular portfolio amount) cannot be
        customised. You may however chose to alter the size of portfolio you create or use manual invest.
    </p>
    <button mat-flat-button class="primary" (click)="matDialogRef.close()">Ok</button>
</div>